import "./index.css";

import Navbar from "./sections/navbar/Navbar";
import Header from "./sections/header/Header";
import About from "./sections/about/About";
import Product from "./sections/product/Product";
import Contact from "./sections/contact/Contact";

export function App() {
  return (
    <main>
      <Navbar />
      <Header />
      <About />
      <Product />
      <Contact />
    </main>
  );
}

export default App;
